import React, { useEffect, useRef, useState } from 'react';
import { FaCalendarAlt, FaChevronDown, FaMapMarkerAlt } from 'react-icons/fa';
import api from '../../api';
import './YoungApprenticeBenefitHolidayCalendar.css';

export default function YoungApprenticeBenefitHolidayCalendar({ reference, companyId, companies: reportCompanies }) {
  const year = Number(String(reference || '').split('/')[1]);
  const [availableCompanies, setAvailableCompanies] = useState([]);
  const [selected, setSelected] = useState('');
  const [calendar, setCalendar] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const request = useRef(0);
  const companies = reportCompanies ?? availableCompanies;
  useEffect(() => {
    if (reportCompanies !== undefined) return undefined;
    let active = true;
    api.get('/student-management/young-apprentice/benefit-holidays').then(({ data }) => {
      if (active) setAvailableCompanies(data.companies || []);
    }).catch(() => { if (active) setError('Não foi possível carregar as empresas do calendário.'); });
    return () => { active = false; };
  }, [reportCompanies]);
  const effectiveCompany = companyId ? String(companyId)
    : companies.some(company => String(company.id) === selected) ? selected : String(companies[0]?.id || '');
  useEffect(() => {
    const id = ++request.current;
    setCalendar(null); setError(''); setLoading(false);
    if (!effectiveCompany || !Number.isInteger(year) || year < 1900 || year > 2100) return undefined;
    setLoading(true);
    api.get('/student-management/young-apprentice/benefit-holidays', { params: { companyId: Number(effectiveCompany), year } }).then(({ data }) => {
      if (id === request.current) setCalendar(data);
    }).catch(e => { if (id === request.current) setError(e?.response?.data?.error || 'Não foi possível carregar os feriados.'); })
      .finally(() => { if (id === request.current) setLoading(false); });
    return () => { request.current++; };
  }, [effectiveCompany, year]);
  const location = [calendar?.location?.city, calendar?.location?.state].filter(Boolean).join(' / ');
  return <details className="ya-benefit-holidays ya-benefit-holidays--report"><summary>
    <span className="ya-benefit-holidays__icon" aria-hidden="true"><FaCalendarAlt /></span>
    <span><strong>Calendário de feriados</strong><small>Confira as datas excluídas do cálculo de benefícios</small></span>
    <FaChevronDown className="ya-benefit-holidays__chevron" aria-hidden="true" />
  </summary><div className="ya-benefit-holidays__content">
    <div className="ya-benefit-holidays__toolbar"><label>Empresa do calendário<select value={effectiveCompany} disabled={Boolean(companyId) || !companies.length} onChange={e => setSelected(e.target.value)}><option value="">Selecione</option>{companies.map(c => <option value={c.id} key={c.id}>{c.tradeName || c.corporateName}{c.status === 'INACTIVE' ? ' · Inativa' : ''}</option>)}</select></label>
      {calendar && <span className="ya-benefit-holidays__location"><FaMapMarkerAlt aria-hidden="true" />{location || 'Localização não informada'}<b>{year}</b></span>}
    </div>
    <p className="ya-benefit-holidays__description">Inclui feriados nacionais e feriados cadastrados aplicáveis à cidade/UF da empresa. Para alterar as datas, acesse Cadastros &gt; Feriados.</p>
    {error && <p role="alert">{error}</p>}{loading && <p role="status">Carregando feriados...</p>}
    {!companies.length && !companyId && <p className="ya-benefit-holidays__description">Nenhuma empresa disponível para o filtro selecionado.</p>}
    {calendar && <>{calendar.locationIncomplete && <p role="status" className="ya-benefit-holidays__warning">Empresa com localização incompleta. Confira a cidade/UF no cadastro da empresa para aplicar os feriados locais; os feriados nacionais e gerais continuam disponíveis.</p>}
      {calendar.holidays?.length ? <ul className="ya-benefit-holidays__dates">{calendar.holidays.map((day, index) => <li key={`${day.date}-${index}`}>
        <time dateTime={day.date}>{day.date.split('-').reverse().join('/')}</time><span>{day.name}</span><small>{day.source}</small>
      </li>)}</ul> : <p className="ya-benefit-holidays__description">Nenhum feriado encontrado para esta empresa no ano consultado.</p>}
    </>}
  </div></details>;
}
